import { Modal } from 'foundations-components/transitional/components/Modal';
import { View } from 'foundations-components/transitional/components/View';
import { LowLevelAuthFlowView } from '../shared/components/LowLevelAuthFlowView';
import { useAuthConfigFetch } from '../shared/hooks/useAuthConfigFetch';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { ModalOrInlineLayout } from '../shared/components/ModalOrInlineLayout';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { LowLevelAuthErrorAlert } from '../shared/components/LowLevelAuthFlowView/LowLevelAuthErrorAlert';
import { AuthenticateError } from '../shared/types/authErrors';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function AuthConfigLoadingState({
  isModal,
  onCancel
}) {
  return /*#__PURE__*/_jsx(ModalOrInlineLayout, {
    isModal: isModal,
    header: isModal ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "unifiedAuthCore.modal.loadingDialogHeader"
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onCancel
      })]
    }) : undefined,
    body: /*#__PURE__*/_jsx(View, {
      minBlockSize: "300px",
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        layout: "centered"
      })
    })
  });
}
export function AuthConfigFetchFailureState({
  isModal,
  onClose,
  appName = '',
  isReauth = false,
  error
}) {
  const authError = error instanceof AuthenticateError ? error.toAuthError() : undefined;
  return /*#__PURE__*/_jsx(ModalOrInlineLayout, {
    isModal: isModal,
    header: isModal ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h2",
        children: appName ? isReauth ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "unifiedAuthCore.modal.reconnectDialogHeader",
          options: {
            appName
          }
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "unifiedAuthCore.modal.dialogHeader",
          options: {
            appName
          }
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "unifiedAuthCore.modal.loadingDialogHeader"
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose
      })]
    }) : undefined,
    body: /*#__PURE__*/_jsx(View, {
      minBlockSize: "300px",
      children: authError ? /*#__PURE__*/_jsx(LowLevelAuthErrorAlert, {
        appName: appName,
        error: authError,
        context: {
          appName,
          onCancel: onClose,
          onReset: onClose
        }
      }) : /*#__PURE__*/_jsx(Alert, {
        type: "danger",
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "unifiedAuthCore.errors.configuration.title"
        }),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "unifiedAuthCore.errors.configuration.body"
        })
      })
    })
  });
}
export function UnifiedAuthView({
  isModal,
  isReauth = false,
  portalId,
  accountId,
  appName,
  modalSettings,
  onComplete,
  onCancel = () => {},
  fetchAuthConfig,
  useIntroScreen,
  useSuccessScreen,
  onAuthError,
  debug = false
}) {
  var _modalSettings$width, _modalSettings$use;
  const configFetchState = useAuthConfigFetch(fetchAuthConfig);
  const children = /*#__PURE__*/_jsx(_Fragment, {
    children: configFetchState.status === 'pending' ? /*#__PURE__*/_jsx(AuthConfigLoadingState, {
      isModal: isModal,
      onCancel: onCancel
    }) : configFetchState.status === 'succeeded' ? /*#__PURE__*/_jsx(LowLevelAuthFlowView, {
      isModal: isModal,
      isReauth: isReauth,
      portalId: portalId,
      authConfig: configFetchState.config,
      onComplete: payload => {
        if (onComplete) onComplete(payload);
      },
      onCancel: onCancel,
      accountId: accountId,
      useIntroScreen: useIntroScreen,
      useSuccessScreen: useSuccessScreen,
      onError: onAuthError,
      debug: debug
    }) : /*#__PURE__*/_jsx(AuthConfigFetchFailureState, {
      isModal: isModal,
      onClose: onCancel,
      appName: appName,
      isReauth: isReauth,
      error: configFetchState.err
    })
  });
  return isModal ? /*#__PURE__*/_jsx(Modal, {
    "data-test-id": "unified-auth-modal",
    width: (_modalSettings$width = modalSettings === null || modalSettings === void 0 ? void 0 : modalSettings.width) !== null && _modalSettings$width !== void 0 ? _modalSettings$width : 550,
    size: modalSettings === null || modalSettings === void 0 ? void 0 : modalSettings.size,
    use: (_modalSettings$use = modalSettings === null || modalSettings === void 0 ? void 0 : modalSettings.use) !== null && _modalSettings$use !== void 0 ? _modalSettings$use : 'default',
    children: children
  }) : /*#__PURE__*/_jsx(View, {
    "data-test-id": "unified-auth-form",
    children: children
  });
}